import { dehydrate, QueryClient } from '@tanstack/react-query';
import { Testimonials as TestimonialsPage } from 'components/pages/Testimonials';
import {
  fetchTestimonials,
  TESTIMONIALS_PAGE_KEY,
} from 'hooks/pages/useTestimonials';
import { prefetchCommonData } from 'utils/buildTime';
import { fetchWithSentry } from 'utils/pageTemplates/fetchWithSentry';

export async function getStaticProps() {
  const queryClient = new QueryClient();

  await fetchWithSentry({
    queryClient,
    queryKey: [TESTIMONIALS_PAGE_KEY],
    queryFn: fetchTestimonials,
    tags: { template: 'testimonials', api: 'sanity' },
    isRequired: true,
  });

  await prefetchCommonData(queryClient);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
}

export default function Testimonials() {
  return <TestimonialsPage />;
}
